import React from "react"

import * as styles from "./AboutImage.module.css"

const AboutImage = ({ image, alt }: { image: string; alt?: string }) => {
  return (
    <div className={styles.aboutImage}>
      <img
        src={image}
        alt={alt ?? "About Press'nXPress Customer Feedback Platform"}
      />
    </div>
  )
}

export default AboutImage
